import { extendTailwindMerge } from 'tailwind-merge';
import { monksTwMergeConfig } from '@monksflow/monks-ui/preset';

/**
 * `twMerge` taught the design system's named steps. Plain `twMerge` cannot tell `gap-sm` and
 * `gap-lg` apart from unknown classes, so it keeps both and CSS source order picks the winner.
 */
export const mergeClasses = extendTailwindMerge<string, string>(monksTwMergeConfig);
